export class Command2D {
    constructor() {
        this._commandBuffer = null;
    }
    recover() {
        this._commandBuffer = null;
        this._context = null;
    }
    destroy() {
        this._commandBuffer = null;
        this._context = null;
    }
}
